export const LONG = 'LONG';
export const SHORT = 'SHORT';
export const NONE = 'NONE';
